module.exports = __webpack_public_path__ + "img/lesitem.f1a008a0.png";